import React, { useState } from "react";
import axios from "axios";
import "../assets/expo_landing_page.css";

import mango from "../assets/imgs/mango.jpg";
import bamboo from "../assets/imgs/bamboo.jpg";
import jackfruit from "../assets/imgs/jackfruit.jpg";

export default function ExpoWaterscape() {

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        city: "",
        budget: "",
        project: "Waterscape – Phase 4"
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://samriddhidevelopers.in/backend/expo_lead.php",
                form,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status === "success") {

                const message = `Hi, I am ${form.name}. Interested in Waterscape Phase 4 (1 Acre @ 18L). Budget: ${form.budget}. I want details.`;

                const encoded = encodeURIComponent(message);

                setTimeout(() => {
                    window.location.href = `https://wa.me/919766010099?text=${encoded}`;
                }, 800);

            } else {
                alert("Failed to save lead");
            }

        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="expo-page">

            {/* HERO */}
            <section 
                className="expo-hero"
                style={{ backgroundImage: `url(${mango})` }}
            >
                <div className="expo-overlay">
                    <h1 className="expo-heading">
                        Own 1 Acre Land @ ₹18 Lakhs
                    </h1>

                    <p className="expo-sub">
                        Earn Up To ₹3 Lakhs Per Year 🌿
                    </p>

                    <button
                        className="expo-primary-btn"
                        onClick={() =>
                            document.getElementById("form").scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Get Details
                    </button>
                </div>
            </section>

            {/* VALUE SECTION */}
            <section className="expo-projects">
                <h2 className="section-title">Why Waterscape?</h2>

                <div className="expo-grid">
                    <div className="expo-card">1 Acre (40 Guntha) Land 🌿</div>
                    <div className="expo-card">Organic Farming Ready 🌱</div>
                    <div className="expo-card">Plantation Included 🌳</div>
                    <div className="expo-card">Water Access 💧</div>
                    <div className="expo-card">Internal Roads 🛣️</div>
                    <div className="expo-card">Passive Income Opportunity 💰</div>
                </div>
            </section>

            {/* IMAGE STRIP (VISUAL TRUST) */}
            <section className="expo-projects">
                <h2 className="section-title">Real Farming Potential</h2>

                <div className="expo-grid">
                    <img src={bamboo} className="expo-card-img" alt="bamboo" />
                    <img src={jackfruit} className="expo-card-img" alt="jackfruit" />
                    <img src={mango} className="expo-card-img" alt="mango" />
                </div>
            </section>

            {/* FORM */}
            <section id="form" className="expo-form-section">
                <h2 className="expo-section-title-white">
                    Get Price & Income Details
                </h2>

                <form className="expo-form" onSubmit={handleSubmit}>

                    <input 
                        name="name" 
                        placeholder="Your Name" 
                        onChange={handleChange} 
                        required 
                    />

                    <input 
                        name="mobile" 
                        placeholder="Mobile Number" 
                        onChange={handleChange} 
                        required 
                    />

                    <input 
                        name="city" 
                        placeholder="City" 
                        onChange={handleChange} 
                        required 
                    />

                    <select name="budget" onChange={handleChange} required>
                        <option value="">Select Budget</option>
                        <option>15-20L</option>
                        <option>20–30L</option>
                        <option>30L+</option>
                        <option>50L+</option>
                    </select>

                    <button 
                        type="submit" 
                        className="expo-primary-btn" 
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Unlock Details on WhatsApp"}
                    </button>

                </form>
            </section>

        </div>
    );
}